import { TaskData } from '../constants/types';

export const getTotalTasks = (data: TaskData): number => 
{
  return data.task_counts['0-tasks'] + data.task_counts['1-tasks'] + data.task_counts['2-tasks'];
};
